import BankTransferForm from '@withdrawals/views/BankTransferForm'
import { WithdrawalSubFlows } from 'mmfintech-backend-api'

const BankTransfer = () => <BankTransferForm flowType={WithdrawalSubFlows.BANKWIRE} />
export default BankTransfer
